import { Box, Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import React from "react";
import { useOldStepperStore } from "../shared/stores/orders/stepper-store.store";

type StepsButtonsProps = {
  handleSubmit: () => void;
  setPreviousAction: (data: any) => void;
  previousStep?: number;
  previousLabel?: string;
  nextLabel?: string;
  isFirst?: boolean;
  isLast?: boolean;
  isValidateStyle?: boolean;
  applyBeforePreviousStep?: () => void;
  setIsLoading?: (isLoading: boolean) => void;
  isLoading?: boolean;
};

export const StepsButtons: React.FC<StepsButtonsProps> = ({
  handleSubmit,
  setPreviousAction,
  previousStep,
  previousLabel = "Précédent",
  nextLabel = "Suivant",
  isFirst = false,
  isLast = false,
  isValidateStyle = false,
  applyBeforePreviousStep = undefined,
  isLoading,
}: StepsButtonsProps) => {
  const { classes } = useStyles({
    isFirst,
    isLast,
  });
  const { updateClickedButton } = useOldStepperStore();
  return (
    <Box className={classes.container}>
      {!isFirst && (
        <Button
          variant="outline"
          size="md"
          loading={isLoading}
          onClick={async () => {
            if (applyBeforePreviousStep) {
              await applyBeforePreviousStep();
            }
            if (previousStep !== undefined) {
              updateClickedButton("PREVIOUS");
              setPreviousAction(previousStep);
            }
          }}
          data-testid="step-button-not-first"
        >
          {previousLabel}
        </Button>
      )}
      {!isLast && (
        <Button
          loading={isLoading}
          size={isValidateStyle ? "lg" : "md"}
          color={isValidateStyle ? "green" : undefined}
          onClick={() => {
            updateClickedButton("NEXT");
            handleSubmit();
          }}
          data-testid="step-button-not-last"
        >
          {nextLabel}
        </Button>
      )}
    </Box>
  );
};

type stepsButtonsStylesProps = {
  isFirst: boolean;
  isLast: boolean;
};

const useStyles = createStyles(
  (theme, { isFirst, isLast }: stepsButtonsStylesProps) => ({
    container: {
      display: "flex",
      justifyContent: isFirst
        ? "flex-end"
        : isLast
          ? "flex-start"
          : "space-between",
    },
  })
);
